Jelly.Interface.Generate_Window = function(Namespace, Parameters)
{
	// TODO: Possibly add something built in, via something like 
/*

return [Format as "Javascript String"]
	<div>
		yay.
	</div>
[/Format];
*/
	// TODO: Remove below

	// Generate window HTML wrapper element with Namespace element inside
	var Window_Element = Jelly.Interface.Generate_Browser_Control({
		Browser_Control_ID: "Window",
		Replace: {"NAMESPACE": Namespace}
	});

	if (Parameters["Container"] && Parameters["Container"].toLowerCase() == "interstitial") {
		$(Window_Element).addClass("Interstitial");
	}
	if (Parameters["Container"] && Parameters["Container"].toLowerCase() == "quick_window") {
		$(Window_Element).addClass("Quick_Window");
	}
	
	return Window_Element;
}
